const Block = ({children}) => {
    return (
        <div style={{background: 'white', padding: '20px', marginBottom: '20px'}} className="rounded block">
            {children}
        </div>
    )
}
export default Block;